import { useEffect, useState } from "react";
import useIsApp from "./useIsApp";

declare global {
  interface Window {
    insets?: {
      top: number;
      bottom: number;
      left: number;
      right: number;
    };
    moduleName: string;
  }
}

const getTopPadding = (isApp: boolean) => {
  if (!__CLIENT__) return 0;
  const insets = window?.insets;
  if (isApp && insets?.top) {
    return insets?.top;
  }
  return 0;
};

const useAppPadding = () => {
  const isApp = useIsApp();
  const [paddingTop, setPaddingTop] = useState(0);

  useEffect(() => {
    setPaddingTop(getTopPadding(isApp));
  }, [isApp]);
  return paddingTop;
};

export default useAppPadding;
